import { call, put, takeEvery } from "redux-saga/effects";

import {
    GET_DATADOG_ALL_RESOURCE_COUNT,
    GET_ALL_ORG_DATADOG_RESOURCE_TYPES,
    GET_DATADOG_ALL_RESOURCE_ALERTS_PAGE,
    POST_DATADOG_SERVICE_MAPPING,
    POST_DATADOG_RESOURCE_OPSGENIE_TEAM_MAPPING,
    POST_DATADOG_RESOURCE_PAGERDUY_SERVICE_MAPPING,
    GET_DATADOG_REFRESH,
    GET_DATADOG_DEFAULT_THRESHOLD,
    GET_DATADOG_DYNAMIC_DEFAULT_THRESHOLD,
    GET_DATADOG_RESOURCES,
    PUT_DATADOG_THRESHOLD,
    POST_DATADOG_DISABLE_THRESHOLD_ALERTS,
    POST_DATADOG_ENABLE_THRESHOLD_ALERTS,
    GET_DATADOG_ALERTS,
    GET_DATADOG_MISSING_ALERTS_BY_RESOURCE_ID,
    GET_DATADOG_RESOURCE_BY_ID,
    GET_DEFAULT_THRESHOLDS_DATADOG_RESOURCE_BY_ID,
    GET_DATADOG_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
    GET_DATADOG_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
    POST_DATADOG_CREATE_RESOURCE_ALERTS,
    PUT_DATADOG_ALERTS,
    POST_DATADOG_ENABLE_ALERTS,
    POST_DATADOG_DISABLE_ALERTS,
    GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE,
    GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT,
    GET_DATADOG_API_ENDPOINTS_BY_APM,
    POST_DATADOG_REGISTER_ENDPOINT,
    GET_USER_RESCAN_STATUS_DATADOG
} from "./actionTypes";

import {
    getDatadogAllResourceCountFail,
    getDatadogAllResourceCountSuccess,
    getAllOrgDatadogResourceTypesFail,
    getAllOrgDatadogResourceTypesSuccess,
    getDatadogAllResourceAlertsPageFail,
    getDatadogAllResourceAlertsPageSuccess,
    postDatadogServiceMappingFail,
    postDatadogServiceMappingSuccess,
    postDatadogResourceOpsgenieTeamMappingFail,
    postDatadogResourceOpsgenieTeamMappingSuccess,
    postDatadogResourcePagerdutyServiceMappingFail,
    postDatadogResourcePagerdutyServiceMappingSuccess,
    getDatadogRefreshFail,
    getDatadogRefreshSuccess,
    getDatadogDefaultThresholdFail,
    getDatadogDefaultThresholdSuccess,
    getDatadogDynamicDefaultThresholdFail,
    getDatadogDynamicDefaultThresholdSuccess,
    getDatadogResourcesFail,
    getDatadogResourcesSuccess,
    putDatadogThresholdFail,
    putDatadogThresholdSuccess,
    postDatadogDisableThresholdAlertsFail,
    postDatadogDisableThresholdAlertsSuccess,
    postDatadogEnableThresholdAlertsFail,
    postDatadogEnableThresholdAlertsSuccess,
    getDatadogAlertsFail,
    getDatadogAlertsSuccess,
    getDatadogMissingAlertsByResourceIdFail,
    getDatadogMissingAlertsByResourceIdSuccess,
    getDatadogResourceByIdFail,
    getDatadogResourceByIdSuccess,
    getDefaultThresholdsDatadogResourceByIdFail,
    getDefaultThresholdsDatadogResourceByIdSuccess,
    getDatadogDynamicAlertsDeployedByResourceIdFail,
    getDatadogDynamicAlertsDeployedByResourceIdSuccess,
    getDatadogMissingDynamicAlertsByResourceIdFail,
    getDatadogMissingDynamicAlertsByResourceIdSuccess,
    postDatadogCreateResourceAlertsFail,
    postDatadogCreateResourceAlertsSuccess,
    putDatadogAlertsFail,
    putDatadogAlertsSuccess,
    postDatadogEnableAlertsFail,
    postDatadogEnableAlertsSuccess,
    postDatadogDisableAlertsFail,
    postDatadogDisableAlertsSuccess,
    getDatadogAllServicesDependencyResourceAlertsFail,
    getDatadogAllServicesDependencyResourceAlertsSuccess,
    getDatadogAllServiceDependencyResourceCountFail,
    getDatadogAllServiceDependencyResourceCountSuccess,
    getDatadogApiEndpointsByApmFail,
    getDatadogApiEndpointsByApmSuccess,
    postDatadogRegisterEndpointFail,
    postDatadogRegisterEndpointSuccess,
    getDataDogRefreshScanStatusFail,
    getDataDogRefreshScanStatusSuccess
} from "./actions";

import {
    getDatadogAllResourceCountUrl,
    getAllOrgDatadogResourceTypesUrl,
    getDatadogAllResourceAlertsPageUrl,
    postDatadogServiceMappingUrl,
    postDatadogResourceOpsgenieTeamMapping,
    postDataDogResourcePagerdutyServiceMappingCall,
    getDatadogRefreshResourcesUrl,
    getDatadogDefaultThresholdUrl,
    getDatadogResourcesUrl,
    postDatadogUpdateThresholdUrl,
    postDatadogDisableThresholdAlertUrl,
    postDatadogEnableThresholdAlertUrl,
    getDatadogAlertsUrl,
    getDatadogMissingAlertsByResourceIDUrl,
    getDatadogResourceByIDUrl,
    getDefaultThresholdsDatadogResourceByIDUrl,
    getDatadogDynamicAlertsDeployedByResourceId,
    getDatadogMissingDynamicAlertsByResourceId,
    postDatadogCreateAlertsUrl,
    putDatadogUpdateAlertUrl,
    postDatadogEnableAlertUrl,
    postDatadogDisableAlertUrl,
    getDatadogAllServiceDependencyResourceAlertsPageUrl,
    getDatadogAllServiceDependencyResourceCountUrl,
    getApiEndpointsByAPMUrl,
    postRegisterEndpointDatadogUrl,
    getRescanStatusDatadogUrl
} from "../../helpers/fakebackend_helper";
import {showNotification} from "../../components/Common/notification";


function* onGetDatadogAllResourceCount({payload: {page_filters}}){
    try {
        const response = yield call(getDatadogAllResourceCountUrl, page_filters);
        yield put(getDatadogAllResourceCountSuccess(response));
    } catch (error) {
        yield put(getDatadogAllResourceCountFail(error));
    }
}

function* onGetAllOrgDatadogResourceTypes(){
    try {
        const response = yield call(getAllOrgDatadogResourceTypesUrl);
        yield put(getAllOrgDatadogResourceTypesSuccess(response));
    } catch (error) {
        yield put(getAllOrgDatadogResourceTypesFail(error));
    }
}

function* onGetDatadogAllResourceAlertsPage({payload: {page_filters}}){
    try {
        const response = yield call(getDatadogAllResourceAlertsPageUrl, page_filters);
        yield put(getDatadogAllResourceAlertsPageSuccess(response));
    } catch (error) {
        yield put(getDatadogAllResourceAlertsPageFail(error));
    }
}

function* onPostDatadogServiceMapping({payload: {service_mapping}}){
    try {
        const response = yield call(postDatadogServiceMappingUrl, service_mapping);
        yield put(postDatadogServiceMappingSuccess(response));
        window.location.reload()
    } catch (error) {
        yield put(postDatadogServiceMappingFail(error));
    }
}

function* onPostDatadogResourceOpsgenieTeamMapping({payload: {datadog_resource_team_mapping}}){
    try {
        const response = yield call(postDatadogResourceOpsgenieTeamMapping, datadog_resource_team_mapping);
        yield put(postDatadogResourceOpsgenieTeamMappingSuccess(response));
    } catch (error) {
        yield put(postDatadogResourceOpsgenieTeamMappingFail(error));
    }
}

function* onPostDatadogResourcePagerDutyServiceMapping({payload: {datadog_resource_pagerduty_service_mapping}}){
    try {
        const response = yield call(postDataDogResourcePagerdutyServiceMappingCall, datadog_resource_pagerduty_service_mapping);
        yield put(postDatadogResourcePagerdutyServiceMappingSuccess(response));
    } catch (error) {
        yield put(postDatadogResourcePagerdutyServiceMappingFail(error));
    }
}

function* onGetDatadogRefresh(){
    try {
        const response = yield call(getDatadogRefreshResourcesUrl);
        yield put(getDatadogRefreshSuccess(response));
        if (response.scan_completed === false){
            showNotification('error', response.message);
        }
    } catch (error) {
        yield put(getDatadogRefreshFail(error));
    }
}

function* onGetDatadogDefaultThreshold(threshold_type){
    try {
        const response = yield call(getDatadogDefaultThresholdUrl, threshold_type.payload);
        yield put(getDatadogDefaultThresholdSuccess(response));
    } catch (error) {
        yield put(getDatadogDefaultThresholdFail(error));
    }
}

function* onGetDatadogDynamicDefaultThreshold(threshold_type){
    try {
        const response = yield call(getDatadogDefaultThresholdUrl, threshold_type.payload);
        yield put(getDatadogDynamicDefaultThresholdSuccess(response));
    } catch (error) {
        yield put(getDatadogDynamicDefaultThresholdFail(error));
    }

}

function* onGetDatadogResources(){
    try {
        const response = yield call(getDatadogResourcesUrl);
        yield put(getDatadogResourcesSuccess(response));
    } catch (error) {
        yield put(getDatadogResourcesFail(error));
    }
}

function* onPutDatadogThreshold({payload: {thresholds}}){
    try {
        const response = yield call(postDatadogUpdateThresholdUrl, thresholds);
        yield put(putDatadogThresholdSuccess(response));
    } catch (error) {
        yield put(putDatadogThresholdFail(error));
    }
}

function* onPostDatadogDisableThresholdAlerts({payload: {alerts}}) {
    const response = yield call(postDatadogDisableThresholdAlertUrl, alerts);
    window.location.reload();
}

function* onPostDatadogEnableThresholdAlerts({payload: {alerts}}) {
    const response = yield call(postDatadogEnableThresholdAlertUrl, alerts);
    window.location.reload();
}

function* onGetDatadogAlerts(monitored_resource_id) {
    try {
        const response = yield call(getDatadogAlertsUrl, monitored_resource_id.payload);
        let final_response = {}
        final_response[monitored_resource_id.payload] = response;
        yield put(getDatadogAlertsSuccess(final_response));
    } catch (error) {
        yield put(getDatadogAlertsFail(error));
    }
}

function* onGetDatadogMissingAlertsByResourceId(monitored_resource_id) {
    try {
        const response = yield call(getDatadogMissingAlertsByResourceIDUrl, monitored_resource_id.payload);
        yield put(getDatadogMissingAlertsByResourceIdSuccess(response));
    } catch (error) {
        yield put(getDatadogMissingAlertsByResourceIdFail(error));
    }
}

function* onGetDatadogResourceById(monitored_resource_id) {
    try {
        const response = yield call(getDatadogResourceByIDUrl, monitored_resource_id.payload);
        yield put(getDatadogResourceByIdSuccess(response));
    } catch (error) {
        yield put(getDatadogResourceByIdFail(error));
    }

}

function* onGetDefaultThresholdsDatadogResourceById(monitored_resource_id) {
    try {
        const response = yield call(getDefaultThresholdsDatadogResourceByIDUrl, monitored_resource_id.payload);
        yield put(getDefaultThresholdsDatadogResourceByIdSuccess(response));
    } catch (error) {
        yield put(getDefaultThresholdsDatadogResourceByIdFail(error));
    }

}

function* onGetDatadogDynamicAlertsDeployedByResourceId(monitored_resource_id) {
    try {
        const response = yield call(getDatadogDynamicAlertsDeployedByResourceId, { monitored_resource_id: monitored_resource_id.payload });
        yield put(getDatadogDynamicAlertsDeployedByResourceIdSuccess(response));
    } catch (error) {
        yield put(getDatadogDynamicAlertsDeployedByResourceIdFail(error));
    }
}

function* onGetDatadogMissingDynamicAlertsByResourceId(monitored_resource_id) {
    try {
        const response = yield call(getDatadogMissingDynamicAlertsByResourceId, { monitored_resource_id: monitored_resource_id.payload });
        yield put(getDatadogMissingDynamicAlertsByResourceIdSuccess(response));
    } catch (error) {
        yield put(getDatadogMissingDynamicAlertsByResourceIdFail(error));
    }

}

function* onPostDatadogCreateResourceAlerts({payload: {alerts}}){
    try {
        const currentUrl = window.location.href;
        const response = yield call(postDatadogCreateAlertsUrl, alerts);
        if (response){
            window.location.reload();
            window.location.href = currentUrl;
        }
    } catch(error) {
        if (error.response.data.message === "Plan has expired") {
            showNotification("error", "Your subscription has expired. Please renew!");
        }
    }
}

function* onPutDatadogUpdateAlerts({payload: {alerts}}){
    try {
        const response = yield call(putDatadogUpdateAlertUrl, alerts);
        if (response){
            window.location.reload()
        }
    } catch(error) {
        if (error.response.data.message === "Plan has expired") {
            showNotification("error", "Your subscription has expired. Please renew!");
        }
    }
}

function* onPostDatadogEnableAlert({payload: {alerts}}){
    try {
        const response = yield call(postDatadogEnableAlertUrl, alerts);
        yield put(postDatadogEnableAlertsSuccess(response));
        window.location.reload()
    } catch(error) {
        yield put(postDatadogEnableAlertsFail(error.message));
    }
}

function* onPostDatadogDisableAlert({payload: {alerts}}){
    try {
        const response = yield call(postDatadogDisableAlertUrl, alerts);
        yield put(postDatadogDisableAlertsSuccess(response));
        window.location.reload()
    } catch(error) {
        yield put(postDatadogDisableAlertsFail(error.message));
    }

}

function* onGetDatadogAllServiceDependencyResourceAlertsPage({payload: {page_filters}}){
    try {
        const response = yield call(getDatadogAllServiceDependencyResourceAlertsPageUrl, page_filters);
        yield put(getDatadogAllServicesDependencyResourceAlertsSuccess(response));
    } catch (error) {
        yield put(getDatadogAllServicesDependencyResourceAlertsFail(error));
    }
}

function* onGetDatadogAllServiceDependencyResourceCount({payload: {page_filters}}){
    try {
        const response = yield call(getDatadogAllServiceDependencyResourceCountUrl, page_filters);
        yield put(getDatadogAllServiceDependencyResourceCountSuccess(response));
    } catch (error) {
        yield put(getDatadogAllServiceDependencyResourceCountFail(error));
    }

}

function* onGetDatadogApiEndpointsByApm({payload: {page_filters}}){
    try {
        const response = yield call(getApiEndpointsByAPMUrl, page_filters);
        yield put(getDatadogApiEndpointsByApmSuccess(response));
    } catch (error) {
        yield put(getDatadogApiEndpointsByApmFail(error));
    }
}

function* onPostDatadogRegisterEndpoint(payload){
    try{
        const response = yield call(postRegisterEndpointDatadogUrl, payload.payload)
        yield put(postDatadogRegisterEndpointSuccess(response));
        showNotification("success", "Endpoint registered successfully")
        // Redirect to data dog page after 2 secs
        setTimeout(() => {
            window.location.href = "/datadog-resources"
        }, 2000)
    } catch (error) {
        yield put(postDatadogRegisterEndpointFail(error.message))
        showNotification("error", "Endpoint registration failed")
    }
}

function* onGetDatadogRefreshScanStatus(){
    try {
        const response = yield call(getRescanStatusDatadogUrl);
        yield put(getDataDogRefreshScanStatusSuccess(response));
    } catch (error) {
        yield put(getDataDogRefreshScanStatusFail(error));
    }
}

function* datadogSaga() {
    yield takeEvery(GET_DATADOG_ALL_RESOURCE_COUNT, onGetDatadogAllResourceCount);
    yield takeEvery(GET_ALL_ORG_DATADOG_RESOURCE_TYPES, onGetAllOrgDatadogResourceTypes);
    yield takeEvery(GET_DATADOG_ALL_RESOURCE_ALERTS_PAGE, onGetDatadogAllResourceAlertsPage);
    yield takeEvery(POST_DATADOG_SERVICE_MAPPING, onPostDatadogServiceMapping);
    yield takeEvery(POST_DATADOG_RESOURCE_OPSGENIE_TEAM_MAPPING, onPostDatadogResourceOpsgenieTeamMapping);
    yield takeEvery(POST_DATADOG_RESOURCE_PAGERDUY_SERVICE_MAPPING, onPostDatadogResourcePagerDutyServiceMapping);
    yield takeEvery(GET_DATADOG_REFRESH, onGetDatadogRefresh);
    yield takeEvery(GET_DATADOG_DEFAULT_THRESHOLD, onGetDatadogDefaultThreshold);
    yield takeEvery(GET_DATADOG_DYNAMIC_DEFAULT_THRESHOLD, onGetDatadogDynamicDefaultThreshold);
    yield takeEvery(GET_DATADOG_RESOURCES, onGetDatadogResources);
    yield takeEvery(PUT_DATADOG_THRESHOLD, onPutDatadogThreshold);
    yield takeEvery(POST_DATADOG_DISABLE_THRESHOLD_ALERTS, onPostDatadogDisableThresholdAlerts);
    yield takeEvery(POST_DATADOG_ENABLE_THRESHOLD_ALERTS, onPostDatadogEnableThresholdAlerts);
    yield takeEvery(GET_DATADOG_ALERTS, onGetDatadogAlerts);
    yield takeEvery(GET_DATADOG_MISSING_ALERTS_BY_RESOURCE_ID, onGetDatadogMissingAlertsByResourceId);
    yield takeEvery(GET_DATADOG_RESOURCE_BY_ID, onGetDatadogResourceById);
    yield takeEvery(GET_DEFAULT_THRESHOLDS_DATADOG_RESOURCE_BY_ID, onGetDefaultThresholdsDatadogResourceById);
    yield takeEvery(GET_DATADOG_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID, onGetDatadogDynamicAlertsDeployedByResourceId);
    yield takeEvery(GET_DATADOG_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID, onGetDatadogMissingDynamicAlertsByResourceId);
    yield takeEvery(POST_DATADOG_CREATE_RESOURCE_ALERTS, onPostDatadogCreateResourceAlerts);
    yield takeEvery(PUT_DATADOG_ALERTS, onPutDatadogUpdateAlerts);
    yield takeEvery(POST_DATADOG_ENABLE_ALERTS, onPostDatadogEnableAlert);
    yield takeEvery(POST_DATADOG_DISABLE_ALERTS, onPostDatadogDisableAlert);
    yield takeEvery(GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE, onGetDatadogAllServiceDependencyResourceAlertsPage);
    yield takeEvery(GET_DATADOG_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT, onGetDatadogAllServiceDependencyResourceCount)
    yield takeEvery(GET_DATADOG_API_ENDPOINTS_BY_APM, onGetDatadogApiEndpointsByApm)
    yield takeEvery(POST_DATADOG_REGISTER_ENDPOINT, onPostDatadogRegisterEndpoint)
    yield takeEvery(GET_USER_RESCAN_STATUS_DATADOG, onGetDatadogRefreshScanStatus)
}

export default  datadogSaga;